/*
 * @tips 拆分规则：根据业务平级（任何页面都不属于谁，都是平级的独立个体）
 * @tips 路由文件名全小写
 */

export default [
	{
		path: '/',
		redirect: '/certquery'
	},
	{
		path: '/certquery',
		component: () => import('../pages/certquery/index'),
		name: 'certquery'
	},
	{
		path: '/authapply',
		component: () => import('../pages/authapply/index'),
		name: 'authapply'
	}
]
